export const soonYouWillBeVoteForText =
  'PRÓXIMAMENTE PODRÁS VOTAR POR TU PAQUETE DE FIESTA FAVORITO'
